export default () => "production" === process.env.NODE_ENV // NODE_ENV is production in staging
